export default __webpack_public_path__ + "static/media/mask10.5211c6c3.jpeg";